
import {
    useRecordContext,
    useNotify, useDataProvider, useRefresh,
    Button,
} from 'react-admin';
import { Fragment, useState } from 'react';
import {
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    Alert,
} from '@mui/material';
import CleaningServicesIcon from '@mui/icons-material/CleaningServices';


const warningColor = '#faada2'; // Example color for warning (yellow)

// Adjust the color to match your design
const alertStyle = {
    backgroundColor: warningColor,
    color: '#000000', // Adjust text color for better contrast if needed
    fontWeight: 'bold'
};

const CleanButton = () => {
    const record = useRecordContext();
    const refresh = useRefresh();
    const notify = useNotify();
    const [isDisabled, setIsDisabled] = useState(false);
    const [openDialog, setOpenDialog] = useState(false);
    const dataProvider = useDataProvider();

    const isDeployed = record.room_id ? true : false;

    const confirmMessage = isDeployed
        ? `⚠️ This session is in PRODUCTION.\nCleaning will permanently remove all deployed resources.
        \nThis action is IRREVERSIBLE.\n\nAre you sure you want to clean training "${record.title}" - locator ${record.locator}?`
        : `Are you sure you want to clean training "${record.title}"?`;

    // === Handle button click ===
    const Handleclick = () => {
        if (!record.room_id) {
            notify(
                <Alert severity="error" sx={{ fontWeight: 'bold' }}>
                    Training <b>{record.title}</b> is not deployed.
                    <br />
                </Alert>,
                { type: 'error' }
            );
            return;
        }
        setOpenDialog(true);
    };

    // === Confirm cleanup ===
    const handleConfirm = async () => {
        setOpenDialog(false);
        setIsDisabled(true);

        try {
            const { data } = await dataProvider.showOne(`task/training/clean/${record.id}`);
            if (data) {
                notify(
                    <Alert severity="success">
                        Training "{record.title}" has been cleaned successfully.
                    </Alert>
                );
            } else {
                notify(
                    <Alert severity="error">
                        No response received from the server. Please try again later.
                    </Alert>
                );
            }
        } catch (error) {
            console.error("error is ", error);
            notify(
                <Alert severity="error">
                    {error.message || 'An unexpected error occurred while cleaning.'}
                </Alert>
            );
        } finally {
            setIsDisabled(false);
            refresh();
        }
    };

    const handleCancel = () => setOpenDialog(false);


    return (
        <Fragment>
            <div>
                <Button
                    onClick={Handleclick}
                    disabled={isDisabled}
                    startIcon={<CleaningServicesIcon />}
                    label="clean"
                />
            </div>

            {/* Confirmation dialog */}
            <Dialog open={openDialog} onClose={handleCancel} maxWidth="xs" fullWidth>
                <DialogTitle>Confirm Cleanup</DialogTitle>
                <DialogContent>
                    <DialogContentText
                        sx={{ whiteSpace: 'pre-line', color: 'error.main', fontWeight: 500 }}
                    >
                        <strong> {confirmMessage} </strong>
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleCancel} color="inherit">
                        Cancel
                    </Button>
                    <Button
                        onClick={handleConfirm}
                        color="error"
                        variant="contained"
                        autoFocus
                    >
                        Confirm
                    </Button>
                </DialogActions>
            </Dialog>
        </Fragment>


    )
}
export default CleanButton;